import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

export default function AuthShield({ children }: PropsWithChildren) {
  if (!localStorage.getItem('token')) {
    return <Navigate to={'/login'} replace />;
  } else {
    return children;
  }
}
